module.exports = __webpack_public_path__ + "static/media/img_demo_data_mobile.eaa08b91.png";